import React from 'react';
import { Spin, Card, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDocument } from 'react-firebase-hooks/firestore';

import Client from 'containers/app/client';
import { ROUTE_EMPLOYER_PREFIX } from 'utils/routes';

const TokensWidget = () => {
  const history = useHistory();

  const ref = Client.dbProfile();
  const [doc, loading, error] = useDocument(ref);
  const [docOrg, loadingOrg, errorOrg] = useDocument(
    doc &&
      doc.data().organization &&
      Client.dbDoc(`organizations/${doc.data().organization}`)
  );

  if (loading || loadingOrg) return <Spin />;

  if (error) throw new Error(error);
  if (errorOrg) throw new Error(errorOrg);

  if (docOrg == null) return <Spin />;

  const { userId: ownerId, admins } = docOrg.data();
  const { tokens = 0 } = doc.data();

  const canBuy = ownerId === Client.currentUserId();
  const canDistribute = canBuy && admins.isGroup;
  const canAsk = admins.isGroup && !canBuy;

  const actions = [];

  if (canBuy)
    actions.push(
      <Button
        type="primary"
        onClick={() => {
          history.push(`${ROUTE_EMPLOYER_PREFIX}/buy-tokens`);
        }}
      >
        Buy Tokens
      </Button>
    );

  if (canDistribute)
    actions.push(
      <Button
        type="primary"
        onClick={() => {
          history.push(`${ROUTE_EMPLOYER_PREFIX}/send-tokens`);
        }}
      >
        Send Tokens
      </Button>
    );

  if (canAsk)
    actions.push(
      <Button
        type="primary"
        onClick={() => {
          history.push(`${ROUTE_EMPLOYER_PREFIX}/request-tokens`);
        }}
      >
        Request Tokens
      </Button>
    );

  return (
    <Card title="Tokens" actions={actions} headStyle={{ textAlign: 'center' }}>
      <h2>{tokens}</h2>
    </Card>
  );
};

export default TokensWidget;
